import Trans from 'next-translate/Trans';

export const VatAndTransportInfo: FC = () => {
    return (
        <small className="mb-[5px] ml-3 text-small font-normal text-primary">
            <Trans
                i18nKey="incl. VAT., excl. <link>shipping costs</link>"
                components={{
                    link: <a className="text-primary" href="/versand-zahlung" tabIndex={0} target="_blank" />,
                }}
            />
        </small>
    );
};
